import React from 'react';

import { Link } from 'common/components/Link';
import { HOTJAR_SUPPRESS_ATTRS } from 'common/constants/hotjar';
import { useLocalization } from 'common/providers/LocaleProvider';
import { getTrackerProps } from 'common/tracking/getTrackerProps';

const LogoutBlock = ({
  not = 'h24_not_your_account',
  logoutURL = 'h24_logout_url',
  firstName = '',
}) => {
  const { r, prefix } = useLocalization();

  return (
    <Link
      {...getTrackerProps(
        {
          ...HOTJAR_SUPPRESS_ATTRS,
          href: prefix.t(logoutURL),
          dangerouslySetInnerHTML: {
            __html: r.t(not, {
              username: firstName,
            }),
          },
        },
        {
          event: 'header_tracking',
          placement: 'userAccountIcon',
          label_identifier: not,
          list_index: 0,
          list_length: 1,
        }
      )}
    />
  );
};

export default LogoutBlock;
